(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('BinDialogController', BinDialogController);

    BinDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Bin'];

    function BinDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Bin) {
        var vm = this;

        vm.bin = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.bin.id !== null) {
                Bin.update(vm.bin, onSaveSuccess, onSaveError);
            } else {
                Bin.save(vm.bin, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:binUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
